export default __webpack_public_path__ + "static/CUPULA _CIELO-e2f9d3cf97dbdd5a025f1b688dbb6dfc.jpg";